import * as angular from "angular";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { CanvasserTrackingDataProvider } from "../../data-provider/canvasser-tracking.dp";
import { CanvassDataProvider } from "../../data-provider/canvass.dp";
import * as _ from "lodash";

let CanvasserTrackingListComponent = {
    selector: "vcCanvasserTrackingList",
    templateUrl:
        "/angular/components/canvasser-tracking/canvasser-tracking-list.component.html",
    bindings: {
        users: "=",
        markers: "=",
        filter: "=",
    },
    controller: class CanvasserTrackingListController {
        // * bindings for typescript compiler *
        public users?: User[];
        public markers?: any[];
        // ************************************

        private $scope: any;
        private dialog: DialogUtils;
        private $filter: any;
        private modelsUtils: any;
        private previousMarkers: object[] = [];

        public filter: any;
        public dataProvider: CanvasserTrackingDataProvider;
        public canvassDataProvider: CanvassDataProvider;
        public permissionProvider: PermissionCheck;
        public scrollLoading = false;
        public allLoaded = false;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            $filter: any,
            CanvasserTrackingDataProvider: CanvasserTrackingDataProvider,
            CanvassDataProvider: CanvassDataProvider,
            PermissionCheck: PermissionCheck,
            ModelsUtils: any
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.$filter = $filter;
            this.modelsUtils = ModelsUtils;

            this.dataProvider = CanvasserTrackingDataProvider;
            this.canvassDataProvider = CanvassDataProvider;
            this.permissionProvider = PermissionCheck;
        }

        distanceColor(canvass: any): string {
            if (canvass.accuracy > 100) return "#bbb";
            if (canvass.distance == null) return "#149364";
            if (canvass.distance < 100) return "#149364";
            if (canvass.distance < 300) return "orange";

            return "red";
        }

        setDayFilter(gps_status: string, dayObject: any, user: any): void {
            angular.forEach(user.formattedCanvasses, (day: any) => {
                day.expanded = false;
            });
            dayObject.expanded = true;

            if (dayObject && gps_status) {
                if (dayObject.filter && dayObject.filter.gps == gps_status) {
                    dayObject.filter.gps = null;
                } else {
                    dayObject.filter = { gps: gps_status };
                }

                dayObject.filtered_canvasses = this.getCanvasses(
                    dayObject,
                    user
                );
            }
        }

        getCanvasses(dayObject: any, user: any): any[] {
            if (
                !dayObject.filter ||
                !dayObject.filter.gps ||
                dayObject.filter.gps == "" ||
                dayObject.filter.gps == "total"
            ) {
                this.markers.splice(0, this.markers.length);
                this.dataProvider.setMarkers(
                    this.markers,
                    dayObject.canvasses,
                    user
                );
                return dayObject.canvasses;
            } else {
                let canvasses = [];

                angular.forEach(dayObject.canvasses, (canvass) => {
                    if (dayObject.filter.gps == "no_gps") {
                        if (!canvass.accuracy || canvass.accuracy > 100) {
                            canvasses.push(canvass);
                        }
                    } else if (dayObject.filter.gps == "verified") {
                        if (
                            canvass.distance == null ||
                            canvass.distance < 100
                        ) {
                            canvasses.push(canvass);
                        }
                    } else if (dayObject.filter.gps == "review") {
                        if (canvass.distance >= 100 && canvass.distance < 300) {
                            canvasses.push(canvass);
                        }
                    } else if (dayObject.filter.gps == "flagged") {
                        if (
                            canvass.accuracy &&
                            canvass.accuracy <= 100 &&
                            canvass.distance > 300
                        ) {
                            canvasses.push(canvass);
                        }
                    }
                });

                this.markers.splice(0, this.markers.length);
                this.dataProvider.setMarkers(this.markers, canvasses, user);
                return canvasses;
            }
        }

        addHousePin(markers: object[], canvass: any): void {
            if (
                !canvass.house ||
                !canvass.house.hid ||
                canvass.house_latitude == null ||
                canvass.house_longitude == null
            ) {
                // Interaction isn't attached to a house (or the house has no
                // saved location) — just toggle the canvass pin on its own
                this.toggleCanvassPin(markers, canvass);
                return;
            }

            let alreadyShowingHouse = this.removeHousePin(
                markers,
                canvass.house.hid
            );
            if (alreadyShowingHouse === "same_house") {
                this.markers = _.cloneDeep(this.previousMarkers);
            } else if (alreadyShowingHouse === "different_house") {
                this.markers = [
                    this.dataProvider.generateCanvassMarker(canvass),
                    this.dataProvider.generateHouseMarker(
                        canvass.house,
                        canvass.house_latitude,
                        canvass.house_longitude
                    ),
                ];
            } else if (!alreadyShowingHouse) {
                this.previousMarkers = _.cloneDeep(markers);
                this.markers = [
                    this.dataProvider.generateCanvassMarker(canvass),
                    this.dataProvider.generateHouseMarker(
                        canvass.house,
                        canvass.house_latitude,
                        canvass.house_longitude
                    ),
                ];
            }
        }

        toggleCanvassPin(markers: object[], canvass: any): void {
            const soloId = "canvass" + canvass.csid;
            const showingSolo =
                markers.length === 1 && (markers[0] as any).id === soloId;

            if (showingSolo) {
                this.markers = _.cloneDeep(this.previousMarkers);
            } else {
                this.previousMarkers = _.cloneDeep(markers);
                this.markers = [
                    this.dataProvider.generateCanvassMarker(canvass),
                ];
            }
        }

        removeHousePin(markers: object[], hid: string): string | boolean {
            let alreadyShowingHouse: string | boolean = false;
            angular.forEach(markers, (marker: any, $index: number) => {
                if (marker.id.includes("house")) {
                    markers.splice($index, 1);
                    alreadyShowingHouse = marker.id.includes(hid)
                        ? "same_house"
                        : "different_house";
                }
            });
            return alreadyShowingHouse;
        }

        getName(person: any): string {
            person = this.modelsUtils.houseOccupant(person);
            return person.identifier();
        }

        scrollLoad(): void {
            if (!this.scrollLoading && !this.dataProvider.allLoaded) {
                this.scrollLoading = true;
                this.dataProvider
                    .getAllUsers(this.filter, this.users.length)
                    .then((response: object) => {
                        this.scrollLoading = false;
                    });
            }
        }

        openViewHouseOccupantDialog(hoid: string, ev: object): void {
            this.dialog.show({
                component: "vc-view-house-occupant",
                targetEvent: ev,
                scope: this.$scope,
                skipHide: true,
                clickOutsideToClose: true,
                locals: {
                    selectedHoid: hoid,
                },
                ariaLabel: "View Person",
                size: "large",
            });
        }

        openViewHouseDialog(hid: string, ev: object): void {
            this.dialog.show({
                component: "vc-view-house",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "View House",
                size: "large",
                locals: {
                    selectedHid: hid,
                    selectedHouse: null,
                },
            });
        }

        userIsOnline(user: User): boolean {
            if (!user || !user.last_canvass) {
                return false;
            }
            return (
                this.$filter("lastsync")(
                    user.last_canvass.cstimestamp
                ).trim() == "online"
            );
        }
    },
};

angular
    .module("canvasserTracking", [])
    .component(
        CanvasserTrackingListComponent.selector,
        CanvasserTrackingListComponent
    );
